import type { Requests } from "../common/request.common";
import type { AgentSubscriptionResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const agentSubscription = {
    record(data: typeof Requests.AgentSubscription.Record.Input) {
        return post<typeof data, AgentSubscriptionResponseTypes.Record>(
            `/agent-subscription/record`,
            data,
        );
    },
    invoiceRecord(id: string) {
        return (data: typeof Requests.AgentSubscription.InvoiceRecord.Input) => {
            return post<typeof data, AgentSubscriptionResponseTypes.InvoiceRecord>(
                `/agent-subscription/invoice-record/${id}`,
                data,
            );
        };
    },
    obtain(id: string) {
        return get<AgentSubscriptionResponseTypes.Obtain>(`/agent-subscription/obtain/${id}`);
    },
};
